module.exports = __webpack_public_path__ + "static/media/banner-novo-agosto.2ae11f3d.jpg";